import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { getSubscriptions } from 'redux/actions';
import InlineLoader from 'components/_core/InlineLoader';
import CancelSubscription from './CancelSubscription';
import UpgradeSubscription from './UpgradeSubscription';
import ResumeSubscription from './ResumeSubscription';

const SubscriptionHeading = styled.h2`
    margin: 0;
    font-weight: normal;
    margin-bottom: 20px;

    .inactive {
        color: #c60000;
    }
    .active {
        color: #33ae23;
    }
    .canceling {
        color: #fff200;
    }
`;

const Property = styled.div`
    margin-bottom: 20px;
    padding-bottom: 20px;
    max-width: 400px;

    border-bottom: 1px solid #222;

    &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border: none;
    }
`;

const PropertyLabel = styled.div`
    font-size: 12px;
    text-transform: uppercase;
    color: #666;
    margin-bottom: 5px;
`;


const PropertyValue = styled.div``;

const Subscriptions = () => {
    const dispatch = useDispatch();
    const fetched = useSelector(state => state.user.subscription.fetched);
    const subState = useSelector(state => state.user.subscription.state) || {};

    useEffect(() => {
        if (!fetched) {
            dispatch(getSubscriptions());
        }
    }, [dispatch, fetched]);

    const formatCurrency = (price, format) => {
        if (!price || !format) {
            return price || '';
        }
        return format.replace('#AMOUNT#', price);
    };

    if (!fetched) {
        return <InlineLoader text="Loading subscriptions" />;
    }

    if (!subState.has_active_subscription) {
        return <SubscriptionHeading>Subscription status: <span className="inactive">Inactive</span></SubscriptionHeading>;
    }

    if (subState.is_lifetime) {
        return (
            <>
                <SubscriptionHeading>Subscription status: <span className="active">Active</span></SubscriptionHeading>
                <Property>
                    <PropertyLabel>Plan</PropertyLabel>
                    <PropertyValue>{subState.plan}</PropertyValue>
                </Property>
            </>
        );
    }

    const nextBillDate = new Date(subState.next_bill_date * 1000);
    const periodEndDate = new Date(subState.sub.current_period_end * 1000);

    const state = subState.canceling ? 'canceling' : 'active';

    return (
        <>
            <SubscriptionHeading>Subscription status: <span className={state}>{state === 'active' ? 'Active' : 'Canceled'}</span></SubscriptionHeading>
            { subState.canceling && <p style={{ margin: '20px 0 25px'}}>You still have access until {periodEndDate.getMonth()+1}/{periodEndDate.getDate()}/{periodEndDate.getFullYear()}</p>}
            {!subState.canceling && <div>
                <Property>
                    <PropertyLabel>Plan</PropertyLabel>
                    <PropertyValue>
                        {subState.plan}
                    </PropertyValue>
                </Property>
                {!subState.canceling && <Property>
                    <PropertyLabel>Next Payment</PropertyLabel>
                    <PropertyValue>{formatCurrency(subState.next_bill_amount, subState.currency_format)} on {nextBillDate.getMonth()+1}/{nextBillDate.getDate()}/{nextBillDate.getFullYear()}</PropertyValue>
                </Property>}
                <UpgradeSubscription />
            </div>}


            {!subState.canceling ? <CancelSubscription /> : <ResumeSubscription />}
        </>
    );
};

export default Subscriptions;